import PageComponent from '../base/PageComponent';

export default class ApprovalHistoryPanel extends PageComponent {
  /**
   * Initialise
   */
  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.childElements('.accordion-title').on('click', (e) => {
      e.preventDefault();
      let accordionTitle = $(e.target).closest('.accordion-title'),
        accordionBody = accordionTitle.next();
      accordionTitle.toggleClass('display');
      if (accordionBody.length) {
        accordionBody.toggleClass('display');
        if (accordionBody.hasClass('display')) {
          console.log(accordionBody.find('a'));
          accordionBody.find('a').stop(true, false).animate({
            'max-height': '100px',
            'opacity': '1'
          }, 400);
        }
        else {
          accordionBody.find('a').stop(true, true).animate({
            'max-height': '0',
            'opacity': '0'
          }, 400);
        }
      }

    });
  }
}
